export enum StudentsSubscriptionPlan {
	FREE_TRIAL = 'Free Trial',
	PRICE_VALUE = 0,
	STARTER_PRO = 'Starter Pro',
}